export const visaOptionsByCountry = [
  {
    country: 'Algeria',
    options: [
      { label: 'Algeria Citizen', value: 'Algeria Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Australia',
    options: [
      { label: 'Australian Citizen', value: 'Australian Citizen', additionalInfo: 'Citizen' },
      { label: 'Australian PR', value: 'Australian PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'Skilled Regional (Provisional) Visa (Subclass 489)',
        value: 'Skilled Regional (Provisional) Visa (Subclass 489)',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Skilled Work Regional (Provisional) Visa (subclass 491)',
        value: 'Skilled Work Regional (Provisional) Visa (subclass 491)',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Subclass 482 Primary',
        value: 'Subclass 482 Primary',
        additionalInfo: 'Authorised with Sponsorship',
      },

      {
        label: 'Temporary Activity Visa (Subclass 408)',
        value: 'Temporary Activity Visa (Subclass 408)',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Temporary Work (International Relations) Visa (Subclass 403)',
        value: 'Temporary Work (International Relations) Visa (Subclass 403)',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Global Talent Visa (Subclass 858)',
        value: 'Global Talent Visa (Subclass 858)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Partner Visa (Subclass 309)',
        value: 'Partner Visa (Subclass 309)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Partner Visa (Subclass 820)',
        value: 'Partner Visa (Subclass 820)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Skilled-Recognised Graduate Visa (Subclass 476)',
        value: 'Skilled-Recognised Graduate Visa (Subclass 476)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Special Category Visa (Subclass 444)',
        value: 'Special Category Visa (Subclass 444)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Subclass 482 Dependent',
        value: 'Subclass 482 Dependent',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Subclass 485 Dependent',
        value: 'Subclass 485 Dependent',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Subclass 485 Primary',
        value: 'Subclass 485 Primary',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Subclass 500 Dependent',
        value: 'Subclass 500 Dependent',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Subclass 500 Primary',
        value: 'Subclass 500 Primary',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Work and Holiday Visa (Subclass 462)',
        value: 'Work and Holiday Visa (Subclass 462)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Working Holiday Visa (Subclass 417)',
        value: 'Working Holiday Visa (Subclass 417)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Bridging Visa', value: 'Bridging Visa', additionalInfo: 'Not Authorised' },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Austria',
    options: [
      { label: 'Austrian Citizen', value: 'Austrian Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'Austrian PR', value: 'Austrian PR', additionalInfo: 'Permanent Resident' },
      { label: 'EU PR', value: 'EU PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'Austrian Single Permit',
        value: 'Austrian Single Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Austrian Work Permit',
        value: 'Austrian Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'EU Work Permit',
        value: 'EU Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Red-White-Red Card',
        value: 'Red-White-Red Card',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Austrian Residence Permit',
        value: 'Austrian Residence Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Bahrain',
    options: [
      { label: 'Bahrain Citizen', value: 'Bahrain Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Belgium',
    options: [
      { label: 'Belgian Citizen', value: 'Belgian Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'Belgian PR', value: 'Belgian PR', additionalInfo: 'Permanent Resident' },
      { label: 'EU PR', value: 'EU PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'Belgian Work Permit',
        value: 'Belgian Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'EU Work Permit',
        value: 'EU Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      { label: 'Orange Card', value: 'Orange Card', additionalInfo: 'Authorised with Sponsorship' },
      { label: 'Type B', value: 'Type B', additionalInfo: 'Authorised with Sponsorship' },
      {
        label: 'Belgian Blue Card',
        value: 'Belgian Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Belgian Blue Card Dependent',
        value: 'Belgian Blue Card Dependent',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Belgian Residence Permit',
        value: 'Belgian Residence Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'EU Settlement Scheme (Pre-Settled Status)',
        value: 'EU Settlement Scheme (Pre-Settled Status)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Professional Card',
        value: 'Professional Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Type A', value: 'Type A', additionalInfo: 'Authorised without Sponsorship' },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Type C (Schengen Visa)',
        value: 'Type C (Schengen Visa)',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Type D (Long-Stay Visa)',
        value: 'Type D (Long-Stay Visa)',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Brazil',
    options: [
      { label: 'Brazil Citizen', value: 'Brazil Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Bulgaria',
    options: [
      { label: 'Bulgaria Citizen', value: 'Bulgaria Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Bulgarian Citizen', value: 'Bulgarian Citizen', additionalInfo: 'Citizen' },
      { label: 'Bulgarian PR', value: 'Bulgarian PR', additionalInfo: 'Permanent Resident' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Canada',
    options: [
      { label: 'Canadian Citizen', value: 'Canadian Citizen', additionalInfo: 'Citizen' },
      { label: 'Open Permit', value: 'Open Permit', additionalInfo: 'Authorised with Sponsorship' },
      {
        label: 'Close Permit',
        value: 'Close Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'China',
    options: [
      { label: 'China PR', value: 'China PR', additionalInfo: 'Permanent Resident' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Croatia',
    options: [
      { label: 'Croatia Citizen', value: 'Croatia Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Czech Republic',
    options: [
      { label: 'CZ Citizen', value: 'CZ Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'EU PR', value: 'EU PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Residence Permit',
        value: 'EU Residence Permit',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Denmark',
    options: [
      { label: 'Danish Citizen', value: 'Danish Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'EU PR', value: 'EU PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Residence Permit',
        value: 'EU Residence Permit',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'Danish Single Permit',
        value: 'Danish Single Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Danish Work Permit',
        value: 'Danish Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Danish Blue Card',
        value: 'Danish Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Danish Residence Permit',
        value: 'Danish Residence Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Type C (Schengen Visa)',
        value: 'Type C (Schengen Visa)',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Type D (Long-Stay Visa)',
        value: 'Type D (Long-Stay Visa)',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Estonia',
    options: [
      { label: 'Estonian Citizen', value: 'Estonian Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Estonian PR', value: 'Estonian PR', additionalInfo: 'Permanent Resident' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Finland',
    options: [
      { label: 'Finnish Citizen', value: 'Finnish Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      {
        label: 'EU Residence Permit',
        value: 'EU Residence Permit',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'Finnish PR', value: 'Finnish PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'Finnish Single Permit',
        value: 'Finnish Single Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Finnish Work Permit',
        value: 'Finnish Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Finnish Residence Permit',
        value: 'Finnish Residence Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'France',
    options: [
      { label: 'French Citizen', value: 'French Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'EU Residence Permit',
        value: 'EU Residence Permit',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'EU Spouse', value: 'EU Spouse', additionalInfo: 'Permanent Resident' },
      { label: 'French PR', value: 'French PR', additionalInfo: 'Permanent Resident' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Germany',
    options: [
      { label: 'German Citizen', value: 'German Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'EU PR', value: 'EU PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Residence Permit',
        value: 'EU Residence Permit',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'EU Spouse', value: 'EU Spouse', additionalInfo: 'Permanent Resident' },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'German PR', value: 'German PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Work Permit',
        value: 'EU Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'German Single Permit',
        value: 'German Single Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'German Work Permit',
        value: 'German Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'EU Blue Card Dependent',
        value: 'EU Blue Card Dependent',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'EU Settlement Scheme (Family Permit)',
        value: 'EU Settlement Scheme (Family Permit)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'German Blue Card',
        value: 'German Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'German Blue Card Dependent',
        value: 'German Blue Card Dependent',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'German Freelancer Visa',
        value: 'German Freelancer Visa',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'German Residence Permit',
        value: 'German Residence Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Type C (Schengen Visa)',
        value: 'Type C (Schengen Visa)',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Type D (Long-Stay Visa)',
        value: 'Type D (Long-Stay Visa)',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Greece',
    options: [
      { label: 'Greek Citizen', value: 'Greek Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Hong Kong',
    options: [
      { label: 'Hong Kong Citizen', value: 'Hong Kong Citizen', additionalInfo: 'Citizen' },
      {
        label: 'Hong Kong PR',
        value: 'Hong Kong PR',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'E Pass', value: 'E Pass', additionalInfo: 'Authorised with Sponsorship' },
      {
        label: 'Employment Visa',
        value: 'Employment Visa',
        additionalInfo: 'Authorised with Sponsorship',
      },
      { label: 'GEP Visa', value: 'GEP Visa', additionalInfo: 'Authorised with Sponsorship' },
      {
        label: 'Hong Kong Dependent Visa',
        value: 'Hong Kong Dependent Visa',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Hong Kong Work Permit',
        value: 'Hong Kong Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      { label: 'IANG Visa', value: 'IANG Visa', additionalInfo: 'Authorised without Sponsorship' },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Hungary',
    options: [
      { label: 'Hungarian Citizen', value: 'Hungarian Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'EU PR', value: 'EU PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Residence Permit',
        value: 'EU Residence Permit',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'India',
    options: [
      { label: 'Indian Citizen', value: 'Indian Citizen', additionalInfo: 'Citizen' },
      { label: 'EU PR', value: 'EU PR', additionalInfo: 'Permanent Resident' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Ireland',
    options: [
      { label: 'Irish Citizen', value: 'Irish Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Spouse', value: 'EU Spouse', additionalInfo: 'Permanent Resident' },
      { label: 'Irish PR', value: 'Irish PR', additionalInfo: 'Permanent Resident' },
      { label: 'CSEP', value: 'CSEP', additionalInfo: 'Authorised with Sponsorship' },
      {
        label: 'CSEP Dependent',
        value: 'CSEP Dependent',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Irish Work Permit',
        value: 'Irish Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      { label: 'Stamp 1', value: 'Stamp 1', additionalInfo: 'Authorised with Sponsorship' },
      { label: 'Stamp 1G', value: 'Stamp 1G', additionalInfo: 'Authorised with Sponsorship' },
      {
        label: 'Stamp 1G Dependent',
        value: 'Stamp 1G Dependent',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Irish Residence Permit',
        value: 'Irish Residence Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Stamp 4', value: 'Stamp 4', additionalInfo: 'Authorised without Sponsorship' },
      {
        label: 'Stamp 4 Dependent',
        value: 'Stamp 4 Dependent',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Stamp 2', value: 'Stamp 2', additionalInfo: 'Not Authorised' },
      {
        label: 'Type D (Long-Stay Visa)',
        value: 'Type D (Long-Stay Visa)',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Italy',
    options: [
      { label: 'Italian Citizen', value: 'Italian Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'Italian PR', value: 'Italian PR', additionalInfo: 'Permanent Resident' },
      { label: 'EU PR', value: 'EU PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'EU Residence Permit',
        value: 'EU Residence Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'Italian Work Permit',
        value: 'Italian Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'EU Work Permit',
        value: 'EU Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'EU Settlement Scheme (Pre-Settled Status)',
        value: 'EU Settlement Scheme (Pre-Settled Status)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Italian Residence Permit',
        value: 'Italian Residence Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'SI (Special Immigration Cases)',
        value: 'SI (Special Immigration Cases)',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Schengen Type C (Short-Stay Visa)',
        value: 'Schengen Type C (Short-Stay Visa)',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Type D (Long-Stay Visa)',
        value: 'Type D (Long-Stay Visa)',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'United Kingdom',
    options: [
      { label: 'British Citizen', value: 'British Citizen', additionalInfo: 'Citizen' },
      { label: 'BNO', value: 'BNO', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Settlement Scheme (Settled Status)',
        value: 'EU Settlement Scheme (Settled Status)',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'EU Settlement Scheme (Pre-Settled Status)',
        value: 'EU Settlement Scheme (Pre-Settled Status)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'EU Settlement Scheme (Family Permit)',
        value: 'EU Settlement Scheme (Family Permit)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'ILR (Indefinite Leave to Remain)',
        value: 'ILR (Indefinite Leave to Remain)',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'FLR (Further Leave to Remain)',
        value: 'FLR (Further Leave to Remain)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Tier 1 Entrepreneur',
        value: 'Tier 1 Entrepreneur',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Tier 1 Exceptional Talent',
        value: 'Tier 1 Exceptional Talent',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Tier 2 General',
        value: 'Tier 2 General',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Tier 2 Dependant',
        value: 'Tier 2 Dependant',
        additionalInfo: 'Authorised with Sponsorship',
      },
      { label: 'Tier 2 ICT', value: 'Tier 2 ICT', additionalInfo: 'Authorised with Sponsorship' },
      {
        label: 'Tier 2 ICT Dependent',
        value: 'Tier 2 ICT Dependent',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Tier 4 General',
        value: 'Tier 4 General',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Tier 4 Dependant',
        value: 'Tier 4 Dependant',
        additionalInfo: 'Authorised with Sponsorship',
      },
      { label: 'Tier 5', value: 'Tier 5', additionalInfo: 'Authorised with Sponsorship' },
      {
        label: 'PSW (Post Study Work)',
        value: 'PSW',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Startup Visa',
        value: 'Startup Visa',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'UK Ancestry Visa',
        value: 'UK Ancestry Visa',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Standard Visitor Visa',
        value: 'Standard Visitor Visa',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Family Visa (Spouse or Partner)',
        value: 'Family Visa (Spouse or Partner)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Family Visa (Spouse or Partner) Dependant',
        value: 'Family Visa (Spouse or Partner) Dependant',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'BRC (Biometric Residence Card)',
        value: 'BRC (Biometric Residence Card)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'BRP (Biometric Residence Permit)',
        value: 'BRP (Biometric Residence Permit)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'DRC (Derivative Residence Card)',
        value: 'DRC (Derivative Residence Card)',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'ECAA (Turkish Businessperson Visa)',
        value: 'ECAA',
        additionalInfo: 'Not Authorised',
      },

      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Japan',
    options: [
      { label: 'Japan Citizen', value: 'Japan Citizen', additionalInfo: 'Citizen' },
      { label: 'Japan PR', value: 'Japan PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'Engineer/Specialist in Humanities/International Services Visa (ESI)',
        value: 'Engineer/Specialist in Humanities/International Services Visa (ESI)',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Specified Skilled Worker Visa',
        value: 'Specified Skilled Worker Visa',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Highly Skilled Professional Visa',
        value: 'Highly Skilled Professional Visa',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Jordan',
    options: [
      { label: 'Jordan Citizen', value: 'Jordan Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Latvia',
    options: [
      { label: 'Latvian Citizen', value: 'Latvian Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'Latvian PR', value: 'Latvian PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Latvia Blue Card',
        value: 'Latvia Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Latvian Residence Permit',
        value: 'Latvian Residence Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Lebanon',
    options: [
      { label: 'Lebanon Citizen', value: 'Lebanon Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Lithuania',
    options: [
      { label: 'Lithuanian Citizen', value: 'Lithuanian Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'Lithuanian PR', value: 'Lithuanian PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Luxembourg',
    options: [
      { label: 'Luxembourgish Citizen', value: 'Luxembourgish Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Spouse', value: 'EU Spouse', additionalInfo: 'Permanent Resident' },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Malaysia',
    options: [
      { label: 'Malaysia Citizen', value: 'Malaysia Citizen', additionalInfo: 'Citizen' },
      { label: 'Malaysia PR', value: 'Malaysia PR', additionalInfo: 'Permanent Resident' },
      { label: 'E Pass', value: 'E Pass', additionalInfo: 'Authorised with Sponsorship' },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Mexico',
    options: [
      { label: 'Moscee Citizen', value: 'Moscee Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Morocco',
    options: [
      { label: 'Morocco Citizen', value: 'Morocco Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Netherlands',
    options: [
      { label: 'Dutch Citizen', value: 'Dutch Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'Dutch PR', value: 'Dutch PR', additionalInfo: 'Permanent Resident' },
      { label: 'EU PR', value: 'EU PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Residence Permit',
        value: 'EU Residence Permit',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'EU Spouse', value: 'EU Spouse', additionalInfo: 'Permanent Resident' },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'Dutch Single Permit',
        value: 'Dutch Single Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Dutch Work Permit',
        value: 'Dutch Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Dutch Blue Card',
        value: 'Dutch Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Dutch Residence Permit',
        value: 'Dutch Residence Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'EU Settlement Scheme (Pre-Settled Status)',
        value: 'EU Settlement Scheme (Pre-Settled Status)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'HSM Dependent',
        value: 'HSM Dependent',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'HSMP', value: 'HSMP', additionalInfo: 'Authorised without Sponsorship' },
      {
        label: 'Zoekjaar Visa',
        value: 'Zoekjaar Visa',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Asylum Residence Permit',
        value: 'Asylum Residence Permit',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Dutch ICT Dependent',
        value: 'Dutch ICT Dependent',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Type C (Schengen Visa)',
        value: 'Type C (Schengen Visa)',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Type D (Long-Stay Visa)',
        value: 'Type D (Long-Stay Visa)',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'New Zealand',
    options: [
      { label: 'New Zealand Citizen', value: 'New Zealand Citizen', additionalInfo: 'Citizen' },
      { label: 'New Zealand PR', value: 'New Zealand PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'North Macedonia',
    options: [
      {
        label: 'North Macedonia Citizen',
        value: 'North Macedonia Citizen',
        additionalInfo: 'Citizen',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Norway',
    options: [
      { label: 'Norwegian Citizen', value: 'Norwegian Citizen', additionalInfo: 'Citizen' },
      { label: 'EU PR', value: 'EU PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'Norwegian PR', value: 'Norwegian PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'Norwegian Single Permit',
        value: 'Norwegian Single Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Norwegian Work Permit',
        value: 'Norwegian Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      { label: 'Blue Card', value: 'Blue Card', additionalInfo: 'Authorised without Sponsorship' },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Family Immigration Permit',
        value: 'Family Immigration Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Norwegian Residence Permit',
        value: 'Norwegian Residence Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Type D (Long-Stay Visa)',
        value: 'Type D (Long-Stay Visa)',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Philippines',
    options: [
      { label: 'Philippines Citizen', value: 'Philippines Citizen', additionalInfo: 'Citizen' },
      { label: 'Philippines PR', value: 'Philippines PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Poland',
    options: [
      { label: 'Polish Citizen', value: 'Polish Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'EU PR', value: 'EU PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Residence Permit',
        value: 'EU Residence Permit',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'EU Spouse', value: 'EU Spouse', additionalInfo: 'Permanent Resident' },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'Polish PR', value: 'Polish PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Single Permit',
        value: 'EU Single Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'EU Work Permit',
        value: 'EU Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Polish Work Permit',
        value: 'Polish Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'EU Blue Card Dependent',
        value: 'EU Blue Card Dependent',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Karta Pobytu',
        value: 'Karta Pobytu',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Karta Polaka',
        value: 'Karta Polaka',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'PESEL', value: 'PESEL', additionalInfo: 'Authorised without Sponsorship' },
      {
        label: 'Poland Blue Card',
        value: 'Poland Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Poland Blue Card Dependent',
        value: 'Poland Blue Card Dependent',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Polish Blue Card',
        value: 'Polish Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Polish Blue Card Dependent',
        value: 'Polish Blue Card Dependent',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Refugee Visa',
        value: 'Refugee Visa',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'PBH', value: 'PBH', additionalInfo: 'Not Authorised' },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Type C (Schengen Visa)',
        value: 'Type C (Schengen Visa)',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Type D (Long-Stay Visa)',
        value: 'Type D (Long-Stay Visa)',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Portugal',
    options: [
      { label: 'Portugal Citizen', value: 'Portugal Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      {
        label: 'EU Residence Permit',
        value: 'EU Residence Permit',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Portugal PR', value: 'Portugal PR', additionalInfo: 'Permanent Resident' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Romania',
    options: [
      { label: 'Romania Citizen', value: 'Romania Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Saudi Arabia',
    options: [
      { label: 'Saudi Arabia Citizen', value: 'Saudi Arabia Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Serbia',
    options: [
      { label: 'Serbia Citizen', value: 'Serbia Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Singapore',
    options: [
      { label: 'Singapore Citizen', value: 'Singapore Citizen', additionalInfo: 'Citizen' },
      { label: 'Singapore PR', value: 'Singapore PR', additionalInfo: 'Permanent Resident' },
      { label: 'E Pass', value: 'E Pass', additionalInfo: 'Authorised with Sponsorship' },
      { label: 'S Pass', value: 'S Pass', additionalInfo: 'Authorised with Sponsorship' },
      { label: 'LTVP', value: 'LTVP', additionalInfo: 'Authorised without Sponsorship' },
      { label: 'PEP Visa', value: 'PEP Visa', additionalInfo: 'Authorised without Sponsorship' },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Slovakia',
    options: [
      { label: 'Slovakia Citizen', value: 'Slovakia Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Slovenia',
    options: [
      { label: 'Slovenia Citizen', value: 'Slovenia Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'South Africa',
    options: [
      { label: 'South Africa Citizen', value: 'South Africa Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'South Sudan',
    options: [
      { label: 'South Sudan Citizen', value: 'South Sudan Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Spain',
    options: [
      { label: 'Spanish Citizen', value: 'Spanish Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'EU PR', value: 'EU PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Residence Permit',
        value: 'EU Residence Permit',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Sweden',
    options: [
      { label: 'Swedish Citizen', value: 'Swedish Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Citizen', value: 'EU Citizen', additionalInfo: 'Citizen' },
      { label: 'EU PR', value: 'EU PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'EU Residence Permit',
        value: 'EU Residence Permit',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'EU Spouse', value: 'EU Spouse', additionalInfo: 'Permanent Resident' },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      { label: 'Swedish PR', value: 'Swedish PR', additionalInfo: 'Permanent Resident' },
      {
        label: 'Swedish Single Permit',
        value: 'Swedish Single Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Swedish Work Permit',
        value: 'Swedish Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'EU Blue Card',
        value: 'EU Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'EU Settlement Scheme (Pre-Settled Status)',
        value: 'EU Settlement Scheme (Pre-Settled Status)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Swedish Blue Card',
        value: 'Swedish Blue Card',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Swedish Residence Permit',
        value: 'Swedish Residence Permit',
        additionalInfo: 'Authorised without Sponsorship',
      },
      { label: 'Job seekar Visa', value: 'Job seekar Visa', additionalInfo: 'Not Authorised' },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      {
        label: 'Type D (Long-Stay Visa)',
        value: 'Type D (Long-Stay Visa)',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Switzerland',
    options: [
      { label: 'Swiss Citizen', value: 'Swiss Citizen', additionalInfo: 'Citizen' },
      { label: 'EU Spouse', value: 'EU Spouse', additionalInfo: 'Permanent Resident' },
      {
        label: 'Family Reunification Visa',
        value: 'Family Reunification Visa',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'Permit C (Settlement Permit)',
        value: 'Permit C (Settlement Permit)',
        additionalInfo: 'Permanent Resident',
      },
      {
        label: 'Permit L (Short-Term Residence Permit)',
        value: 'Permit L (Short-Term Residence Permit)',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Swiss Blue Card',
        value: 'Swiss Blue Card',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Swiss Work Permit',
        value: 'Swiss Work Permit',
        additionalInfo: 'Authorised with Sponsorship',
      },
      {
        label: 'Permit B (Residence Permit)',
        value: 'Permit B (Residence Permit)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Permit F (Provisional Admission Permit)',
        value: 'Permit F (Provisional Admission Permit)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Permit G (Cross-Border Commuter Permit)',
        value: 'Permit G (Cross-Border Commuter Permit)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Permit S (Protection Status Permit)',
        value: 'Permit S (Protection Status Permit)',
        additionalInfo: 'Authorised without Sponsorship',
      },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Thailand',
    options: [
      { label: 'Thailand Citizen', value: 'Thailand Citizen', additionalInfo: 'Citizen' },
      {
        label: 'Required Sponsorship',
        value: 'Required Sponsorship',
        additionalInfo: 'Not Authorised',
      },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Tunisia',
    options: [
      { label: 'Tunisia Citizen', value: 'Tunisia Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Turkey',
    options: [
      { label: 'Turkey Citizen', value: 'Turkey Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'Ukraine',
    options: [
      { label: 'Ukraine Citizen', value: 'Ukraine Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'United Arab Emirates',
    options: [
      { label: 'UAE Citizen', value: 'UAE Citizen', additionalInfo: 'Citizen' },
      { label: 'Other', value: 'Other', additionalInfo: 'Other' },
    ],
  },
  {
    country: 'United States',
    options: [
      { label: 'US Citizen', value: 'US Citizen', additionalInfo: 'Citizen' },
      { label: 'Green Card', value: 'Green Card', additionalInfo: 'Permanent Resident' },
      { label: 'H-1B', value: 'H-1B', additionalInfo: 'Authorised with Sponsorship' },
      { label: 'H4 EAD', value: 'H4 EAD', additionalInfo: 'Authorised without Sponsorship' },
      { label: 'L2 EAD', value: 'L2 EAD', additionalInfo: 'Authorised without Sponsorship' },
      { label: 'EAD', value: 'EAD', additionalInfo: 'Authorised without Sponsorship' },
      { label: 'Required H-1B', value: 'Required H-1B', additionalInfo: 'Not Authorised' },
      { label: 'CPT', value: 'CPT', additionalInfo: 'Authorised with Sponsorship' },
      { label: 'OPT', value: 'OPT', additionalInfo: 'Authorised with Sponsorship' },
      { label: 'TN Visa', value: 'TN Visa', additionalInfo: 'Authorised without Sponsorship' },
      { label: 'Other', value: 'Other', additionalInfo: 'Others' },
    ],
  },
];

export const CountryOptions = [
  { label: 'Algeria', value: 'Algeria' },
  { label: 'Australia', value: 'Australia' },
  { label: 'Austria', value: 'Austria' },
  { label: 'Bahrain', value: 'Bahrain' },
  { label: 'Belgium', value: 'Belgium' },
  { label: 'Brazil', value: 'Brazil' },
  { label: 'Bulgaria', value: 'Bulgaria' },
  { label: 'Canada', value: 'Canada' },
  { label: 'China', value: 'China' },
  { label: 'Croatia', value: 'Croatia' },
  { label: 'Czech Republic', value: 'Czech Republic' },
  { label: 'Denmark', value: 'Denmark' },
  { label: 'Estonia', value: 'Estonia' },
  { label: 'Finland', value: 'Finland' },
  { label: 'France', value: 'France' },
  { label: 'Germany', value: 'Germany' },
  { label: 'Greece', value: 'Greece' },
  { label: 'Hong Kong', value: 'Hong Kong' },
  { label: 'Hungary', value: 'Hungary' },
  { label: 'India', value: 'India' },
  { label: 'Ireland', value: 'Ireland' },
  { label: 'Italy', value: 'Italy' },
  { label: 'Japan', value: 'Japan' },
  { label: 'Jordan', value: 'Jordan' },
  { label: 'Latvia', value: 'Latvia' },
  { label: 'Lebanon', value: 'Lebanon' },
  { label: 'Lithuania', value: 'Lithuania' },
  { label: 'Luxembourg', value: 'Luxembourg' },
  { label: 'Malaysia', value: 'Malaysia' },
  { label: 'Mexico', value: 'Mexico' },
  { label: 'Morocco', value: 'Morocco' },
  { label: 'Netherlands', value: 'Netherlands' },
  { label: 'New Zealand', value: 'New Zealand' },
  { label: 'North Macedonia', value: 'North Macedonia' },
  { label: 'Norway', value: 'Norway' },
  { label: 'Philippines', value: 'Philippines' },
  { label: 'Poland', value: 'Poland' },
  { label: 'Portugal', value: 'Portugal' },
  { label: 'Romania', value: 'Romania' },
  { label: 'Saudi Arabia', value: 'Saudi Arabia' },
  { label: 'Serbia', value: 'Serbia' },
  { label: 'Singapore', value: 'Singapore' },
  { label: 'Slovakia', value: 'Slovakia' },
  { label: 'Slovenia', value: 'Slovenia' },
  { label: 'South Africa', value: 'South Africa' },
  { label: 'South Sudan', value: 'South Sudan' },
  { label: 'Spain', value: 'Spain' },
  { label: 'Sweden', value: 'Sweden' },
  { label: 'Switzerland', value: 'Switzerland' },
  { label: 'Thailand', value: 'Thailand' },
  { label: 'Tunisia', value: 'Tunisia' },
  { label: 'Turkey', value: 'Turkey' },
  { label: 'Ukraine', value: 'Ukraine' },
  { label: 'United States', value: 'United States' },
  { label: 'United Arab Emirates', value: 'United Arab Emirates' },
  { label: 'United Kingdom', value: 'United Kingdom' },
];
